// src/locales/ta/returnBatch.js
export const returnBatch = {
  // Page Titles
  createReturnBatch: "ரிட்டர்ன் செயல்படுத்தவும்",
  allReturnBatches: "Return தொகுப்புகள்",
  returnBatchDetails: "Return தொகுப்பின் விவரங்கள்",
  viewAndManageAllReturnBatches: "அனைத்து return தொகுப்புகளையும் காண்க மற்றும் மேலாண்மை செய்யவும்",

  // Main Interface
  scanToReturn: "ரிட்டர்ன் செய்ய Scan செய்யவும்",
  scanAirwaybillOrOrder: "Airwaybill அல்லது Order Number ஐ Scan செய்யவும்",
  scanPlaceholder: "Barcode scan செய்யவும் அல்லது order/airwaybill எண் உள்ளிடவும்...",

  // Courier & Warehouse Selection
  selectCourier: "Courier Account ஐத் தேர்ந்தெடுக்கவும்",
  selectCourierFirst: "தொடங்க Courier Account தேர்வு செய்யவும்",
  selectWarehouse: "கையிருப்பு (Warehouse) தேர்வு செய்யவும்",
  selectWarehouseFirst: "தொடங்க கையிருப்பு தேர்வு செய்யவும்",
  courierRequired: "Courier Account தேவையானது",
  warehouseRequired: "கையிருப்பு தேவையானது",

  // Batch Management
  activeBatch: "Active தொகுப்பு",
  noBatchFound: "Active தொகுப்பு கிடைக்கவில்லை",
  newBatchWillBeCreated: "முதல் scan இல் புதிய தொகுப்பு உருவாக்கப்படும்",
  multipleBatchesFound: "பல தொகுப்புகள் கிடைத்தன",
  selectBatch: "தொகுப்பைத் தேர்வு செய்யவும்",
  createNewBatch: "புதிய தொகுப்பு உருவாக்கவும்",
  batchNumber: "தொகுப்பு எண்",
  switchBatch: "Batch மாற்றவும்",
  closeBatch: "Batch மூடவும்",
  confirmCloseBatch: "{batchNumber} தொகுப்பை மூட வேண்டுமா? இந்த செயலை பின்னர் மாற்ற முடியாது.",
  confirmBulkClose: "{count} தொகுப்புகளை மூட வேண்டுமா?",
  batchClosedSuccessfully: "Batch வெற்றிகரமாக மூடப்பட்டது",
  bulkClosedSuccessfully: "{count} தொகுப்புகள் வெற்றிகரமாக மூடப்பட்டன",
  failedToCloseBatch: "Batch மூட தோல்வி",
  failedToCloseSomeBatches: "சில தொகுப்புகளை மூட முடியவில்லை",
  noActiveBatchesSelected: "செயல்பாட்டிலுள்ள தொகுப்பு எதுவும் தேர்ந்தெடுக்கப்படவில்லை",

  // Current Batch Info
  currentBatch: "தற்போதைய தொகுப்பு",
  totalOrders: "மொத்த Orders",
  totalValue: "மொத்த மதிப்பு",
  createdBy: "உருவாக்கியவர்",
  createdAt: "உருவாக்கப்பட்ட தேதி",

  // Scan Results
  orderReturned: "Order வெற்றிகரமாக Return செய்யப்பட்டது",
  returnFailed: "Return தோல்வியடைந்தது",
  orderNumber: "Order எண்",
  airwaybillNumber: "Airwaybill",
  customerName: "வாடிக்கையாளர்",
  grandTotal: "மொத்தம்",
  codAmount: "COD தொகை",
  paymentType: "Payment வகை",
  shop: "Shop",
  newStatus: "புதிய நிலை",

  // Stock Movements
  stockRestored: "Stock மீட்டெடுக்கப்பட்டது",
  stockMovements: "Stock நகர்வு",
  productName: "பொருள்",
  quantityRestored: "மீட்டெடுத்த அளவு",
  viewStockDetails: "Stock விவரங்களை காண்க",

  // Recent Returns
  recentReturns: "சமீபத்திய Returns",
  noReturnsYet: "இந்த session இல் Return இல்லை",
  returnedOrders: "Return செய்யப்பட்ட Orders இங்கு காண்பிக்கப்படுகின்றன",

  // Error Messages
  orderNotFound: "Order கிடைக்கவில்லை",
  orderAlreadyReturned: "Order ஏற்கனவே Return செய்யப்பட்டது",
  orderNotDispatched: "Order dispatch செய்யவில்லை",
  orderFromDifferentCourier: "இந்த order வேறு Courier-இனது",
  orderFromDifferentWarehouse: "இந்த order வேறு Warehouse-இனது",
  orderAlreadyClosed: "Order ஏற்கனவே மூடப்பட்டுள்ளது",
  scanRequired: "Scan செய்யவும்",
  failedToReturn: "Order Return செய்ய முடியவில்லை",
  failedToLoadBatches: "Return தொகுப்புகளை load செய்ய முடியவில்லை",
  failedToLoadReferenceData: "Reference data load தோல்வி",
  failedToCreateBatch: "தொகுப்பு உருவாக்க முடியவில்லை",
  failedToLoadBatchDetails: "தொகுப்பு விவரங்களை load செய்ய முடியவில்லை",

  // Notes
  addNotes: "குறிப்புகளை சேர்க்கவும்",
  notesPlaceholder: "இந்த தொகுப்பு குறித்து குறிப்புகளை எழுதவும்...",
  notes: "குறிப்புகள்",
  batchNotes: "தொகுப்பு குறிப்புகள்",
  returnNotes: "Return குறிப்புகள்",
  notesOptional: "குறிப்புகள் (விருப்பத்தேர்வு)",

  // Actions
  clear: "Clear",
  viewDetails: "விவரங்களை பார்க்க",
  viewAllBatches: "அனைத்து தொகுப்புகளையும் பார்க்க",
  processReturns: "Returns செயல்படுத்தவும்",
  closeSelected: "தேர்வு செய்ததை மூடவும் ({count})",
  back: "மீண்டும்",
  backToBatches: "தொகுப்புகளுக்கு திரும்ப",
  addMoreOrders: "மேலும் Order சேர்க்கவும்",
  printReport: "Report Print செய்யவும்",
  exportOrders: "Orders Export செய்யவும்",
  createBatchNow: "தொகுப்பை இப்போது உருவாக்கவும்",
  createBatch: "Batch உருவாக்கவும்",
  cancel: "ரத்து செய்யவும்",
  processing: "செயலாக்கப்படுகிறது...",
  closing: "மூடுகிறது...",

  // Statistics
  todayReturns: "இன்றைய Returns",
  sessionReturns: "இந்த session",
  batchReturns: "Batch Returns",
  batchValue: "Batch Value",
  thisSession: "இந்த Session",
  avgOrderValue: "சராசரி Order Value",
  codOrders: "COD Orders",
  prepaidOrders: "Prepaid Orders",

  // Keyboard Shortcuts
  keyboardShortcuts: "Keyboard shortcuts",
  focusInput: "Input-க்கு கவனம் மாற்று",
  submitScan: "Scan submit செய்",
  clearForm: "Form clear செய்",
  newBatch: "புதிய Batch",

  // Empty States
  noActiveBatch: "செயலில் உள்ள தொகுப்பு இல்லை",
  selectCourierToBegin: "Return செயல்படுத்த Courier account தேர்வு செய்யவும்",
  noReturnBatchesYet: "Return தொகுப்புகள் இல்லை. Return செய்யத் தொடங்குங்கள்.",
  noBatchesFound: "உங்கள் தேடலை பொருத்த தொகுப்புகள் இல்லை",
  noOrdersFound: "Orders கிடைக்கவில்லை",
  noOrdersMatchFilters: "Filters பொருந்தும் order எதுவும் கிடைக்கவில்லை",

  // Validation
  identifierRequired: "Order identifier தேவை",
  pleaseScanOrder: "Order ஐ Scan செய்யவும்",
  pleaseSelectCourier: "Courier account தேர்வு செய்யவும்",
  pleaseSelectWarehouse: "கையிருப்பு தேர்வு செய்யவும்",

  // Success Messages
  batchCreatedSuccessfully: "Return தொகுப்பு வெற்றிகரமாக உருவாக்கப்பட்டது",
  orderAddedSuccessfully: "Order வெற்றிகரமாக சேர்க்கப்பட்டது",
  batchCreatedAutomatically: "Batch {batchNumber} தானாக உருவாக்கப்பட்டது",
  orderReturnedSuccessfully: "Order {orderNumber} வெற்றிகரமாக Return செய்யப்பட்டது",
  ordersExportedSuccessfully: "Orders வெற்றிகரமாக export செய்யப்பட்டது",

  // Filter Labels
  warehouse: "கையிருப்பு",
  courierCompany: "Courier நிறுவனம்",
  courierAccount: "Courier account",
  account: "Account",
  courier: "Courier",
  orders: "Orders",
  dateRange: "தேதி வரம்பு",
  searchByBatchNumber: "Batch number மூலம் தேடவும்...",
  searchOrders: "Orders தேடவும்...",
  allWarehouses: "அனைத்து கையிருப்புகள்",
  allCourierCompanies: "அனைத்து Courier நிறுவனங்கள்",
  allCourierAccounts: "அனைத்து Courier Accounts",
  allStatuses: "அனைத்து Status",
  allStatus: "அனைத்து Status",

  // Status Labels
  statusActive: "Active",
  statusClosed: "Closed",
  status: "Status",
  success: "வெற்றி",
  failed: "தோல்வி",
  pending: "நிலுவையில்",
  restored: "மீட்டெடுக்கப்பட்டது",
  notRestored: "மீட்டெடுக்கப்படவில்லை",

  // Headers & Sections
  setup: "Setup",
  multipleActiveBatchesFound: "பல Active தொகுப்புகள் கிடைத்தன",
  orderReturnedSuccessfully: "Order வெற்றிகரமாக Return செய்யப்பட்டது!",
  scanToRestoreInventory: "Inventory மீட்டெடுக்க Scan செய்யவும்",
  loadingBatchDetails: "தொகுப்பு விவரங்கள் load ஆகின்றன...",
  batchNotFound: "Batch கிடைக்கவில்லை",

  // Details Page
  created: "உருவாக்கப்பட்டது",
  closed: "மூடப்பட்டது",
  by: "ஆல்",
  unknown: "Unknown",
  copyAirwaybill: "Airwaybill நகலெடுக்கவும்",

  // Breakdowns
  paymentTypeBreakdown: "Payment Type Breakdown",
  shopBreakdown: "Shop Breakdown",
  activityTimeline: "Activity Timeline",
  ordersInBatch: "தொகுப்பிலுள்ள Orders",

  // Order Details
  orderDetails: "Order விவரங்கள்",
  deliveryAddress: "டெலிவரி முகவரி",
  contactNumbers: "தொடர்பு எண்கள்",
  orderStatus: "Order நிலை",
  currentStatus: "தற்போதைய நிலை",
  errorMessage: "பிழை செய்தி",
  primary: "Primary",

  // Timeline
  batchCreated: "Batch உருவாக்கப்பட்டது",
  orderAdded: "Order {orderNumber} சேர்க்கப்பட்டது",
  addedBy: "சேர்த்தவர்",
  closedBy: "மூடியவர்",

  // Table Headers
  airwaybill: "Airwaybill",
  customer: "வாடிக்கையாளர்",
  phone: "தொலைபேசி",
  city: "நகரம்",
  payment: "கட்டணம்",
  orderValue: "Order மதிப்பு",
  stock: "Stock",
  returnedBy: "Return செய்தவர்",
  returnedAt: "Return செய்யப்பட்ட தேதி",

  // Misc
  na: "N/A",
  qty: "Qty",

  // Order Items & Product List
  items: "பொருட்கள்",
  orderItems: "ஆர்டர் பொருட்கள்",
  productListTitle: "பொருட்கள் பட்டியல் ({{count}})",
  viewOrdersTab: "ஆர்டர்கள்",
  viewProductsTab: "பொருட்கள்",
  searchProductsPlaceholder: "பொருட்களைத் தேடவும்...",
  productColumn: "பொருள்",
  skuColumn: "SKU",
  totalQuantityColumn: "மொத்த அளவு",
  orderCountColumn: "ஆர்டர்கள்",
  loadingProductList: "பொருட்கள் பட்டியல் ஏற்றப்படுகிறது...",
  noProductsFound: "பொருட்கள் எதுவும் இல்லை",
  noProductsFoundDescription: "உங்கள் தற்போதைய வடிகட்டிகளுக்கு பொருந்தும் பொருட்கள் இல்லை",
  loadProductListError: "பொருட்கள் பட்டியலை ஏற்ற முடியவில்லை",
  printProductList: "அச்சிடு",
  exportExcel: "Excel",
  exportPdf: "PDF"
};
